module.exports = __webpack_public_path__ + "img/_brandschutz.4297c1dd.svg";